import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setCheckWallet, setConfirmWallet } from "../redux/actions/app";
import { closePopup } from "../redux/actions/modal";
import CrossCloseButton from "./parts/CrossCloseButton";

export default function () {
  const textButton = useSelector((state) => state.modal.data.textButton);
  const text = useSelector((state) => state.modal.data.text);
  const dispatch = useDispatch();

  const confirmHandler = (e) => {
    e.preventDefault();
  };

  const approveHandler = (e) => {
    e.preventDefault();
    return dispatch(closePopup());
  };

  return (
    <div className="modal modal_w308 modal-wallet">
      <div className="modal-wallet__close-window">
        <CrossCloseButton />
      </div>

      <form className="modal-form modal-wallet-form confirm_wallet">
        <h4>{text}</h4>
        <button
          className="custom-button modal-wallet__btn"
          onClick={confirmHandler}
        >
          <span>{textButton}</span>
        </button>
      </form>
    </div>
  );
}
